import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { trackWindowScroll } from 'react-lazy-load-image-component';
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

import { LABELS } from '../../constants';
import { hostUrlConverter, imgUrlConverter, sliderSettings } from '../../util';
import { ProductCard } from './components';

const GradProducts = React.memo(({ tileData, isPhotoCard, altImage, scrollPosition, promoCodes, googleAnalytics }) => {
    const [soldOutData, setSoldOutData] = useState({})
    const [productTilesData, setProductTilesData] = useState([])
    useEffect(() => {
        if (Object.keys(tileData) && Object.keys(tileData).length > 0 && tileData?.products?.length > 0) {
            const productData = [...tileData?.products]
            productData.sort((a,b) => {
                if (a.orderSeq && b.orderSeq) {
                    if(a.orderSeq === b.orderSeq) {
                        return a.displayName > b.displayName ? 1 : -1
                    }
                  return  a.orderSeq - b.orderSeq
                } else if (a.orderSeq) {
                    return -1
                } else {
                    return 1
                }
            })
            if(tileData?.products?.length > 6) {
                productData.splice(5, 0, {
                    "actionUrl": tileData?.actionUrl,
                    "imageUrl": productData[0]?.imageUrl,
                    "altImageText": "shopAllButton-"+productData[0]?.displayName
                })
            }
            let  saleProductsData = productData?.map((productObj, key) => {
                let  promoProduct =  promoCodes?.find(o=>productObj.prodRefCode == o.prodRefCode);
                if(promoProduct){
                    productObj.promoText = promoProduct.promoText
                }
                return productObj
            })
            setProductTilesData({ ...tileData, products:saleProductsData })
        }
    }, [tileData])

    useEffect(() => {
        const url = '/apps/store/api/v1.1/soldout-products'
        axios.get(url,
          {
              headers: {
                  "Content-Type": "application/json"
              }
          })
          .then(({data}) => {
              if (data.length) {
                const soldOutProductData = data.reduce((acc, product) => {
                  if (product.productOsr) {
                    acc[product.productOsr] = product
                  }
                  return acc
                }, {});
          
                setSoldOutData(soldOutProductData);
              }
          })
      }, [])
    
    const contentType = 'GraduationProducts'

    if (Object.keys(productTilesData) && Object.keys(productTilesData).length > 0 && productTilesData?.products?.length > 0) {
        return (
            <div className="product-categories">
                <div className="mt-3 container-fluid">
                    <div>
                        <span className="h6 pr-2">{tileData?.displayName}</span>
                        <a rel="nofollow" href={hostUrlConverter(tileData?.actionUrl)} 
                            className="jos-ga-tracking-element fa-xs"
                            data-jos-ga-tracking={JSON.stringify({
                                _resolveFields: {
                                    businessUnit: { 
                                        catalogOsr: googleAnalytics?.catalogOSR,
                                    },
                                    productLine: { 
                                        catalogOsr: googleAnalytics?.catalogOSR 
                                    }
                                },
                                clickText: `${LABELS.SHOP_ALL} (${tileData?.products?.length})`, 
                                modalType: '', 
                                itemName: tileData?.displayName, 
                                actionType: 'button_click', 
                                categoryName: tileData?.displayName,
                                contentType,
                                contentName: tileData?.displayName
                            })}
                        >
                            {`${LABELS.SHOP_ALL} (${tileData?.products?.length})`}
                        </a>
                    </div>
                    <hr />
                    <Slider {...sliderSettings(productTilesData?.products?.length)} className="carousel">
                        {productTilesData?.products?.map((productObj, index) => {
                            const isLimitedSizeProduct = soldOutData[productObj?.prodRefCode] && soldOutData[productObj?.prodRefCode]?.featureOsr
                            const isSoldOutProduct = soldOutData[productObj?.prodRefCode] && !soldOutData[productObj?.prodRefCode]?.featureOsr
                            const shouldShowSeeDetails = index === 5 && productTilesData.products?.length > 6

                            const productCardProps = {
                                handleImageError: (e) => (e.target.src = altImage),
                                handleProductClick: async () => {
                                    if (window?.jostensGaTracking?.gaEventsSpecPromise) {
                                        await Promise.all([window.jostensGaTracking.gaEventsSpecPromise])
                                    }
                                    window.location.assign(hostUrlConverter(productObj?.actionUrl))
                                },
                                handleSeeDetailsClick: async () => {
                                    if (window?.jostensGaTracking?.gaEventsSpecPromise) {
                                        await Promise.all([window.jostensGaTracking.gaEventsSpecPromise])
                                    }
                                    window.location.assign(hostUrlConverter(tileData?.actionUrl))
                                },
                                imageAlt: productObj?.displayName ? productObj?.displayName + "." : productObj?.altImageText,
                                imageSrc: isPhotoCard ? productObj?.imageUrl : imgUrlConverter(productObj?.imageUrl || altImage),
                                index,
                                isGradProductTiles: true,
                                isLimitedSizeProduct,
                                isSoldOutProduct,
                                priceComponentData: productObj,
                                productName: productObj?.displayName,
                                productNameLink: hostUrlConverter(productObj?.actionUrl),
                                promoMessage: productObj?.promoText,
                                scrollPosition,
                                shouldDisplayPrice: !isSoldOutProduct && productObj && Object.keys(productObj)?.length > 0,
                                shouldShowSeeDetails,
                                googleAnalytics,
                                contentType,
                                sectionTitle: tileData?.displayName || ''
                            }

                            return <ProductCard {...productCardProps} />
                        })}
                    </Slider>
                </div>
            </div>)
    } else {
        return null
    }
})

export default trackWindowScroll(GradProducts)